import React, { useEffect, useRef, useState } from "react";
import { Input, Button, Avatar, List, Typography } from "antd";
import { SendOutlined, UserOutlined } from "@ant-design/icons";
import { API } from "../../Axios/Axios";
import { insertForVerifierChat, insertNewMsgOfEmp } from "../../Helpers/APIEndpoints/Endpoints";
import { useAuthStore } from "../../AuthStore/AuthStore";


const { TextArea } = Input;

interface Message {
    id: number;
    text: string;
    from: "Me" | "Support";
    date: string;
}

const ChatBox = (props: any) => {
    console.log('///////////////////inside chat box ///////////', props.message)
    console.log('///////////////////inside chat box ///////////', props.touserid)
    const [messages, setMessages] = useState<Message[]>([]);
    const { userId, currentFinancialYearId } = useAuthStore();
    const [input, setInput] = useState("");
    const bottomRef = useRef<HTMLDivElement | null>(null);
    const messageListRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        const mappedMessages = props?.message.map((ele: any) => ({
            id: ele.Id,
            text: ele.message,
            //from: ele.userId != 0 ? "Support" : "Me",
            from: ele.CreatedBy == userId ? "Me" : "Support",
            fromUserName: ele.fromUserName,
            date: new Date(ele.date).toLocaleString()
        }));

        setMessages(mappedMessages);
    }, [props.message])

    // useEffect(() => {
    //     bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    // }, [messages]);

    useEffect(() => {
        if (messageListRef.current) {
            messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
        }
    }, [messages]);



    const sendMessage = () => {
        if (input.trim() === "") return;
        const newMsg: Message = {
            id: messages.length + 1,
            text: input,
            from: "Me",
            date: new Date().toLocaleString(),
        };
        insertNewMsg(newMsg);
        setMessages([...messages, newMsg]);
        setInput("");
    };

    const insertNewMsg = async (msg: any) => {

        if (props?.type.toLowerCase().includes('verifier')) {
            const res = await API.post(insertForVerifierChat, {
                Message: msg?.text,
                ToUserId: props?.touserid,
                UserId: userId,
                FinancialYearId: currentFinancialYearId,
            })
            console.log('insert after response ====>>>>>>>>>', res.data.data)
        }
        else {
            const res = await API.post(insertNewMsgOfEmp, {
                Message: msg?.text,
                UserId: userId,
                FinancialYearId: currentFinancialYearId,
            })
            console.log('insert after response ====>>>>>>>>>', res.data.data)
        }


    }

    return (
        <div className="chat-container">

            <div className="message-list" ref={messageListRef}>
                <List
                    dataSource={messages}
                    renderItem={(item) => (
                        <div
                            className={`chat-bubble ${item.from === "Me" ? "Me" : "Support"}`}
                        >
                            <Avatar
                                icon={<UserOutlined />}
                                //src={`https://randomuser.me/api/portraits/${item.from === "me" ? "women" : "men"}/1.jpg`}
                                size="small"
                            />
                            <div className="bubble">
                                <Typography.Text>{item.text}</Typography.Text>
                                <div className="d-flex justify-content-between gap-5 date-txt">
                                    <div>{item.date}</div>
                                    <div>{item.from === "Me" ? "Me" : (item.fromUserName.trim() ? item.fromUserName : "Support")}</div>
                                </div>
                            </div>
                        </div>
                    )}
                />
                <div ref={bottomRef} />

            </div>

            <div className="chat-input">
                <TextArea
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Text message"
                    autoSize={{ minRows: 1, maxRows: 3 }}
                    onPressEnter={(e) => {
                        e.preventDefault();
                        sendMessage();
                    }}
                    onKeyPress={(e) => {
                        const charCode = e.which ? e.which : e.keyCode;
                        const char = String.fromCharCode(charCode);

                        if (/^[a-zA-Z0-9 ]+$/.test(char)) {
                            return;
                        }

                        e.preventDefault();
                    }}
                    onPaste={(e) => {
                        e.preventDefault();
                        const pastedText = e.clipboardData.getData("Text");

                        // Apply regex to allow only alphanumeric and underscore
                        const filteredText = pastedText.replace(/[^a-zA-Z0-9 ]/g, "");

                        // Optionally append it to the current input
                        setInput((prev) => prev + filteredText);
                    }}
                />
                <Button
                    type="primary"
                    shape="circle"
                    icon={<SendOutlined />}
                    onClick={sendMessage}
                />
            </div>

        </div>
    );
}

export default ChatBox;